/**
 * Per-product endpoints, hard-coded (spec §6.2): a pane talks to exactly one backend, fixed at pairing.
 * Nothing here is configurable at runtime, so a page cannot be talked into sending a token elsewhere.
 */

export type Product = "ask" | "firm";

export interface ProductConfig {
  product: Product;
  /** Shown to the user. Brand is "Jurisio" (never "Ask" alone in copy). */
  label: string;
  apiBase: string;
  /** Where the user signs in and types the pairing code. */
  connectUrl: string;
  /** Route prefix of the Word add-in endpoints on `apiBase`. */
  routePrefix: string;
  /** Chat job route on `apiBase` (create = POST, poll = GET `/{request_id}`). */
  chatJobsPath: string;
  /** False until that product's backend ships (Firm host is decided by spike P5). */
  available: boolean;
}

export const PRODUCTS: Readonly<Record<Product, ProductConfig>> = Object.freeze({
  ask: Object.freeze({
    product: "ask",
    label: "Jurisio Ask",
    apiBase: "https://api.scholar.jurisio.ai",
    connectUrl: "https://ask.jurisio.ai/word-connect",
    routePrefix: "/v1/scholar/word-addin",
    chatJobsPath: "/v1/scholar/chat/jobs",
    available: true,
  }),
  firm: Object.freeze({
    product: "firm",
    label: "Jurisio Firm",
    apiBase: "https://api.app.jurisio.ai",
    connectUrl: "https://app.jurisio.ai/word-connect",
    routePrefix: "/v1/word-addin",
    // Placeholder until the Firm Word host is chosen (spike P5); never called while `available` is false.
    chatJobsPath: "/v1/word-addin/turns",
    available: false,
  }),
});

/** JWT audience of every Word add-in token (never the web app's audience, spec §6.1). */
export const WORD_ADDIN_AUDIENCE = "word-addin";
